import React from 'react';
import { Wifi, WifiOff, Radio, Loader2 } from 'lucide-react';
import {ConnectionState} from "../../../enum";


const ConnectionStatus = ({ connectionState, rtcStatus }) => {
  const getConnectionIcon = (state) => {
    switch (state) {
      case ConnectionState.CONNECTED:
        return <Wifi className="w-4 h-4 text-green-400" />;
      case ConnectionState.CONNECTING:
      case ConnectionState.RECONNECTING:
        return <Loader2 className="w-4 h-4 text-yellow-400 animate-spin" />;
      default:
        return <WifiOff className="w-4 h-4 text-red-400" />;
    }
  };

  const getWebRTCIcon = (status) => {
    switch (status) {
      case 'connected':
        return <Radio className="w-4 h-4 text-green-400 animate-pulse" />;
      case 'connecting':
        return <Loader2 className="w-4 h-4 text-yellow-400 animate-spin" />;
      default:
        return <Radio className="w-4 h-4 text-zinc-600" />;
    }
  };

  return (
    <div className="flex items-center gap-3">
      <div className={`
        px-3 py-2 rounded-xl flex items-center gap-2 text-sm font-medium transition-all duration-300
        ${connectionState === ConnectionState.CONNECTED 
          ? 'bg-green-500/25 text-green-600 border border-green-500/20 shadow-lg shadow-green-500/10' 
          : 'bg-yellow-500/20 text-yellow-600 border border-yellow-500/20'
        }
      `}>
        {getConnectionIcon(connectionState)}
        <span>Chat</span>
      </div>
      <div className={`
        px-3 py-2 rounded-xl flex items-center gap-2 text-sm font-medium transition-all duration-300
        ${rtcStatus === 'connected' 
          ? 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/20 shadow-lg shadow-emerald-500/10' 
          : rtcStatus === 'connecting' 
            ? 'bg-yellow-500/20 text-yellow-400 border border-yellow-500/20' 
            : 'bg-zinc-800/50 text-zinc-200 border border-white/5'
        }
      `}>
        {getWebRTCIcon(rtcStatus)}
        <span>Voice</span>
      </div>
    </div>
  );
};

export default ConnectionStatus;